import { appData } from '@/mocks/home';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1000px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 p-8 md:p-12 rounded-2xl bg-gradient-to-br from-primary-500/8 via-background-100 to-accent-500/8 border border-background-200/40">
          <div className="flex-shrink-0">
            <div className="w-40 h-40 md:w-48 md:h-48 rounded-2xl bg-background-200/60 border border-background-300/40 flex items-center justify-center overflow-hidden">
              <div className="text-center">
                <i className="ri-smartphone-line text-5xl text-primary-400"></i>
                <p className="text-xs text-foreground-500 mt-2">扫码下载APP</p>
              </div>
            </div>
          </div>
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-100">{appData.title}</h2>
            <p className="text-sm text-foreground-400 mt-4 leading-relaxed max-w-lg">{appData.subtitle}</p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3 mt-6">
              {appData.features.map((f) => (
                <span key={f} className="flex items-center gap-1.5 px-4 py-2 rounded-lg bg-background-200/50 text-xs font-medium text-foreground-300 whitespace-nowrap">
                  <i className="ri-check-line text-primary-400 text-sm"></i>
                  {f}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}